$(function () {
  // 初始化
  let activeId;
  const hash = location.hash.split("#")[1] || 1;
  $(".app-village-article .tab-list .tab-list-item")
    .eq(hash - 1)
    .addClass("line-hover");
  activeId = $(".tab-list .tab-list-item")
    .eq(hash - 1)
    .attr("data-id");
  $(`.tab-content img[data-id="${activeId}"]`).addClass("show");

  // tab切换
  $(".app-village-article .tab-list .tab-list-item").on("click", function () {
    const index = $(".tab-list-item").index(this) + 1;
    location.hash = index; //切换保存hash值
    $(".tab-list-item").removeClass("line-hover");
    $(".tab-list-item")
      .eq(index - 1)
      .addClass("line-hover");
    $(".tab-content img").removeClass("show");
    activeId = $(".tab-list .tab-list-item")
      .eq(index - 1)
      .attr("data-id");
    $(`.tab-content img[data-id="${activeId}"]`).addClass("show");
  });
});
